var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useQuery } from 'react-query';
import * as API from '../API';
export const Subscriber = ({ as: Tag = "div", className, display = true, children }) => {
    return (display ? _jsx(Tag, { className: className ? `subscriber ${className}` : 'subscriber', children: children })
        : null);
};
const fetchSubscriberStatus = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield API.fetchSubscriberStatus();
});
Subscriber.LoggedIn = ({ as: Tag = 'div', children, className = '' }) => {
    const { data: subscriberStatus } = useQuery('kb/abostat', fetchSubscriberStatus, { staleTime: 0, cacheTime: 0 });
    const clsx = ['logged-in', className].join(' ');
    return ((subscriberStatus === null || subscriberStatus === void 0 ? void 0 : subscriberStatus.isLoggedIn) ? _jsx(Tag, { className: clsx, children: children })
        : _jsx(_Fragment, {}));
};
Subscriber.NotLoggedIn = ({ as: Tag = 'div', children, className = '' }) => {
    const { data: subscriberStatus } = useQuery('kb/abostat', fetchSubscriberStatus, { staleTime: 0, cacheTime: 0 });
    const clsx = ['not-logged-in', className].join(' ');
    return (!(subscriberStatus === null || subscriberStatus === void 0 ? void 0 : subscriberStatus.isLoggedIn) ? _jsx(Tag, { className: clsx, children: children })
        : _jsx(_Fragment, {}));
};
Subscriber.Eligible = ({ children }) => {
    const { data: subscriberStatus } = useQuery('kb/abostat', fetchSubscriberStatus, { staleTime: 0, cacheTime: 0 });
    return (subscriberStatus === null || subscriberStatus === void 0 ? void 0 : subscriberStatus.isEligible) ? (_jsx("div", { className: "eligible", children: children })) : _jsx(_Fragment, {});
};
Subscriber.NotEligible = ({ children }) => {
    const { data: subscriberStatus } = useQuery('kb/abostat', fetchSubscriberStatus, { staleTime: 0, cacheTime: 0 });
    return (!(subscriberStatus === null || subscriberStatus === void 0 ? void 0 : subscriberStatus.isEligible)) ? (_jsx("div", { className: "not-eligible", children: children })) : _jsx(_Fragment, {});
};
